import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';
import { getKillSwitch } from 'Selectors/common';

export const getKillSwitchOn = (state: AdminState | ClientState): boolean => getKillSwitch(state).killSwitchOn;